<div class="silvio-santos-holding w-100" [ngClass]="{ 'shift-grid': isMobile }">
  <a
    *ngIf="holding && !isMobile"
    id="silvioSantosHoldingLink"
    [href]="holding.href"
    target="blank"
    rel="noopener"
    class="silvio-santos-holding__link text-decoration-none">
    <figure class="mb-0">
      <picture>
        <img
          class="silvio-santos-holding__logo"
          [src]="holding.image"
          [alt]="holding.title" />
      </picture>
    </figure>

    <div class="silvio-santos-holding__text">
      <ng-content></ng-content>
    </div>
  </a>

  @for (company of groupCompanies; track $index) {
    <a
      [attr.id]="'footerGroup-' + $index"
      [href]="company.href"
      target="_blank"
      rel="noopener">
      <figure class="mb-0">
        <picture>
          <img class="w-auto" [src]="company.image" [alt]="company.title" />
        </picture>
      </figure>
    </a>
  }
</div>
